import { render, staticRenderFns } from "./IndexWaitReadTable.vue?vue&type=template&id=148519bd&scoped=true"
import script from "./IndexWaitReadTable.vue?vue&type=script&lang=js"
export * from "./IndexWaitReadTable.vue?vue&type=script&lang=js"
import style0 from "./IndexWaitReadTable.vue?vue&type=style&index=0&id=148519bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148519bd",
  null
  
)

export default component.exports